const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const formatMessage = require('format-message');
const Chart = require('chart.js/auto');
const Papa = require('papaparse');
const XLSX = require('xlsx');

const menuIconURI = `data:image/png;base64,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`

class Scratch3TableCharts {
    constructor(runtime) {
        this.runtime = runtime;
        this.tables = {};
        this.clear = this.clear.bind(this);
        this.clearCanvas = this.clearCanvas.bind(this);
        if (this.runtime) {
            this.runtime.on('PROJECT_LOADED', this.clear);
            this.runtime.on('RUNTIME_DISPOSED', this.clear);
        }
    }

    getInfo() {
        return {
            id: 'chart',
            blockIconURI: menuIconURI,
            menuIconURI: menuIconURI,
            name: formatMessage({
                id: 'chart.categoryName',
                default: 'Tables and Charts'
            }),
            blocks: [
                {
                    opcode: 'createTable',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.createTable',
                        default: 'create table [TABLE_NAME]'
                    }),
                    arguments: {
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable'
                        }
                    }
                },
                {
                    opcode: 'insertColumn',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.insertColumn',
                        default: 'insert column [COLUMN_NAME] into table [TABLE_NAME]'
                    }),
                    arguments: {
                        COLUMN_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Column1'
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'insertRowData',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.insertRowData',
                        default: 'insert data into table [TABLE_NAME] row [ROW_NUMBER] column [COLUMN_NAME] value [VALUE]'
                    }),
                    arguments: {
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        },
                        ROW_NUMBER: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        COLUMN_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Column1'
                        },
                        VALUE: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Undefined'
                        }

                    }
                },
                {
                    opcode: 'getRowCount',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'chart.getRowCount',
                        default: 'number of rows in table [TABLE_NAME]'
                    }),
                    arguments: {
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'getColumnCount',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'chart.getColumnCount',
                        default: 'number of columns in table [TABLE_NAME]'
                    }),
                    arguments: {
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'deleteRow',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.deleteRow',
                        default: 'delete row [ROW_NUMBER] from table [TABLE_NAME]'
                    }),
                    arguments: {
                        ROW_NUMBER: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'deleteColumn',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.deleteColumn',
                        default: 'delete column [COLUMN_NAME] from table [TABLE_NAME]'
                    }),
                    arguments: {
                        COLUMN_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Column1'
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'deleteTable',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.deleteTable',
                        default: 'delete table [TABLE_NAME]'
                    }),
                    arguments: {
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'showTable',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.showTable',
                        default: 'show table [TABLE_NAME]'
                    }),
                    arguments: {
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'uploadFile',
                    blockType: BlockType.COMMAND,
                    text: 'upload file for table',
                    arguments: {}
                },
                {
                    opcode: 'extractRow',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.extractRow',
                        default: 'extract row [ROW_INDEX] from table [TABLE_NAME]'
                    }),
                    arguments: {
                        ROW_INDEX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                
                {
                    opcode: 'selectQuery',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.selectQuery',
                        default: 'select [COLUMNS]  from table [TABLE_NAME]'
                    }),
                    arguments: {
                        COLUMNS: {
                            type: ArgumentType.STRING,
                            defaultValue: '*'
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'whereClause',
                    blockType: BlockType.COMMAND,
                    text: 'where [CONDITION1] [OPERATOR] [CONDITION2] from [TABLE]',
                    arguments: {
                        CONDITION1: {
                            type: ArgumentType.STRING,
                            defaultValue: 'column1'
                        },
                        OPERATOR: {
                            type: ArgumentType.STRING,
                            menu: 'operatorMenu'
                        },
                        CONDITION2: {
                            type: ArgumentType.STRING,
                            defaultValue: 'value1'
                        },
                        TABLE: {
                            type: ArgumentType.STRING,
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'orderByQuery',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'chart.orderByQuery',
                        default: 'order by [COLUMN_NAME] [ASC_DESC] from [TABLE_NAME]'
                    }),
                    arguments: {
                        COLUMN_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Column1'
                        },
                        ASC_DESC: {
                            type: ArgumentType.STRING,
                            defaultValue: 'asc',
                            menu: 'ascDescMenu' // Add a dropdown with "asc" and "desc" options
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'groupByQuery',
                    blockType: BlockType.COMMAND,
                    text: 'group by [COLUMNS] from [TABLE_NAME]',
                    arguments: {
                        COLUMNS: {
                            type: ArgumentType.STRING,
                            defaultValue: 'column1', // Default column, can be any valid column name
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'havingClause',
                    blockType: BlockType.COMMAND,
                    text: 'having [COLUMN] [COMPARISON_OPERATOR] [VALUE] from [TABLE_NAME]',
                    arguments: {
                        COLUMN: {
                            type: ArgumentType.STRING,
                            defaultValue: 'column1'
                        },
                        COMPARISON_OPERATOR: {
                            type: ArgumentType.STRING,
                            menu: 'comparisonOperatorMenu'
                        },
                        VALUE: {
                            type: ArgumentType.STRING,
                            defaultValue: '100'
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            menu: 'tableMenu'
                        }
                    }
                },
                {
                    opcode: 'aggregateFunctions',
                    blockType: BlockType.REPORTER,
                    text: 'agg fun [FUNCTION] on [COLUMN] from [TABLE_NAME]',
                    arguments: {
                        FUNCTION: {
                            type: ArgumentType.STRING,
                            menu: 'aggregateFunctionMenu'
                        },
                        COLUMN: {
                            type: ArgumentType.STRING,
                            defaultValue: 'column1'
                        },
                        TABLE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'MyTable',
                            menu: 'tableMenu'
                        }
                    }
                }, 
                                  
            ],
            menus: {
                tableMenu: {
                    acceptReporters: true,
                    items: 'getTableNames'
                },
                operatorMenu: {
                    items: ["==",  ">",  "<", ">=", "<=", "<>"],
                    acceptReporters: true
                },
                ascDescMenu: {
                    items: ["ASC", "DESC"],
                    acceptReporters: true
                },
                comparisonOperatorMenu: {
                    items: [">", "<"],
                    acceptReporters: true
                },
                aggregateFunctionMenu: {
                    items: ['SUM', 'AVERAGE', 'STDDEV'], 
                    acceptReporters: true
                }                   
            }
        };
    }

    createTable(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        if (tableName === '') {
            return 'Table name cannot be empty';
        }

        if (this.tables.hasOwnProperty(tableName)) {
            return `Table "${tableName}" already exists`;
        } else {
            this.tables[tableName] = {
                columns: [],
                rows: []
            };
            return `Empty table "${tableName}" created successfully`;
        }
    }

    getTableNames() {
        const tableNames = Object.keys(this.tables);
        if (tableNames.length === 0) {
            return ['No tables yet'];
        }
        return tableNames;
    }

    insertColumn(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const columnName = Cast.toString(args.COLUMN_NAME).trim();
        if (tableName === 'No tables yet') {
            return 'Please create a table first';
        }
        if (!this.tables.hasOwnProperty(tableName)) {
            return `Table "${tableName}" does not exist`;
        }
        if (columnName === '') {
            return 'Column name cannot be empty';
        }
        const table = this.tables[tableName];
        // Check if the column already exists
        if (table.columns.includes(columnName)) {
            return `Column "${columnName}" already exists in table "${tableName}"`;
        }
        // Add the new column
        table.columns.push(columnName);
        // Add empty values for the new column in existing rows
        for (let row of table.rows) {
            row.push('');
        }
        return `Column "${columnName}" inserted into table "${tableName}" successfully`;
    }

    insertRowData(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const rowNumber = Cast.toNumber(args.ROW_NUMBER);
        const columnName = Cast.toString(args.COLUMN_NAME).trim();

        // Check if VALUE is a number or string
        let value;
        if (!isNaN(args.VALUE)) {
            value = Cast.toNumber(args.VALUE); // Convert numeric strings to numbers
        } else {
            value = Cast.toString(args.VALUE).trim(); // Keep non-numeric strings as strings
        }

        if (tableName === 'No tables yet' || !this.tables.hasOwnProperty(tableName)) {
            return `Please select a valid table`;
        }
        if (columnName === 'Select a table first') {
            return `Please select a table and then a column`;
        }
        if (!this.tables.hasOwnProperty(tableName)) {
            return `Table "${tableName}" does not exist`;
        }
        const table = this.tables[tableName];
        if (table.columns.length === 0) {
            return `Table "${tableName}" has no columns. Please add columns first.`;
        }
        if (!table.columns.includes(columnName)) {
            return `Column "${columnName}" does not exist in table "${tableName}"`;
        }
        const columnIndex = table.columns.indexOf(columnName);
        // Ensure the row exists, create it if it doesn't
        while (table.rows.length < rowNumber) {
            table.rows.push(Array(table.columns.length).fill(''));
        }
        // Insert the data
        table.rows[rowNumber - 1][columnIndex] = value;
        return `Data inserted into table "${tableName}", row ${rowNumber}, column "${columnName}"`;
    }


    getRowCount(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        if (!this.tables.hasOwnProperty(tableName)) {
            return 0; // Return 0 if the table doesn't exist
        }
        return this.tables[tableName].rows.length;
    }

    getColumnCount(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        if (!this.tables.hasOwnProperty(tableName)) {
            return 0; // Return 0 if the table doesn't exist
        }
        return this.tables[tableName].columns.length;
    }

    deleteRow(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const rowNumber = Cast.toNumber(args.ROW_NUMBER);

        if (!this.tables.hasOwnProperty(tableName)) {
            return `Table "${tableName}" does not exist`;
        }
        const table = this.tables[tableName];

        if (rowNumber < 1 || rowNumber > table.rows.length) {
            return `Invalid row number. Table "${tableName}" has ${table.rows.length} rows`;
        }
        // Remove the row
        table.rows.splice(rowNumber - 1, 1);
        return `Row ${rowNumber} deleted from table "${tableName}"`;
    }

    deleteColumn(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const columnName = Cast.toString(args.COLUMN_NAME).trim();

        if (!this.tables.hasOwnProperty(tableName)) {
            return `Table "${tableName}" does not exist`;
        }
        const table = this.tables[tableName];
        const columnIndex = table.columns.indexOf(columnName);
        if (columnIndex === -1) {
            return `Column "${columnName}" does not exist in table "${tableName}"`;
        }
        // Remove the column from the columns array
        table.columns.splice(columnIndex, 1);
        // Remove the corresponding data from each row
        for (let row of table.rows) {
            row.splice(columnIndex, 1);  // Change this line
        }
        return `Column "${columnName}" deleted from table "${tableName}"`;
    }

    deleteTable(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();

        if (!this.tables.hasOwnProperty(tableName)) {
            return `Table "${tableName}" does not exist`;
        }
        // Delete the table
        delete this.tables[tableName];

        return `Table "${tableName}" has been deleted`;
    }

    calculateColumnCounts(column) {
        const counts = {};
        column.forEach(value => {
            counts[value] = (counts[value] || 0) + 1;
        });
        return counts;
    }

    createModal(content, title = '', chartData = null) {
        const modal = document.createElement('div');
        modal.className = 'stemblocks-table-modal stemblocks-overlay-modal';
        modal.style.position = 'fixed';
        modal.style.left = '0';
        modal.style.top = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        modal.style.backgroundColor = 'rgba(0,0,0,0.5)';
        modal.style.display = 'flex';
        modal.style.justifyContent = 'center';
        modal.style.alignItems = 'center';
        modal.style.zIndex = '9999';
        const container = document.createElement('div');
        container.style.backgroundColor = 'white';
        container.style.padding = '20px';
        container.style.borderRadius = '5px';
        container.style.width = '65%';
        container.style.height = '90%';
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.maxHeight = '90vh';
        if (title) {
            const titleElement = document.createElement('h3');
            titleElement.textContent = title;
            titleElement.style.fontSize = '1.2em';
            titleElement.style.margin = '0 0 10px 0';
            container.appendChild(titleElement);
        }
        const buttonWrapper = document.createElement('div');
        buttonWrapper.style.marginBottom = '10px';
        const tableButton = document.createElement('button');
        tableButton.textContent = 'Show Table';
        tableButton.style.marginRight = '10px';
        tableButton.style.padding = '5px 10px';
        tableButton.style.cursor = 'pointer';
        tableButton.style.fontWeight = 'bold'; // Set default to bold for table view
        tableButton.onclick = () => {
            contentWrapper.style.display = 'flex';
            chartWrapper.style.display = 'none';
            tableButton.style.fontWeight = 'bold';
            chartButton.style.fontWeight = 'normal';
        };
        const chartButton = document.createElement('button');
        chartButton.textContent = 'Show Chart';
        chartButton.style.padding = '5px 10px';
        chartButton.style.cursor = 'pointer';
        chartButton.style.fontWeight = 'normal'; // Set default to normal for chart view
        chartButton.onclick = () => {
            contentWrapper.style.display = 'none';
            chartWrapper.style.display = 'flex';
            chartButton.style.fontWeight = 'bold';
            tableButton.style.fontWeight = 'normal';
        };
        buttonWrapper.appendChild(tableButton);
        buttonWrapper.appendChild(chartButton);
        container.appendChild(buttonWrapper);
        const contentWrapper = document.createElement('div');
        contentWrapper.style.flexGrow = '1';
        contentWrapper.style.overflowY = 'auto';
        contentWrapper.style.display = 'flex';
        contentWrapper.style.flexDirection = 'column';
        contentWrapper.style.height = 'calc(100% - 100px)';
        const tableWrapper = document.createElement('div');
        tableWrapper.style.width = '100%';
        tableWrapper.style.overflowX = 'auto';
        tableWrapper.style.flexShrink = '0';
        tableWrapper.appendChild(content);
        contentWrapper.appendChild(tableWrapper);
        const chartWrapper = document.createElement('div');
        chartWrapper.style.width = '100%';
        chartWrapper.style.flexGrow = '1';
        chartWrapper.style.display = 'none'; // Initially hidden
        chartWrapper.style.flexDirection = 'column';
        if (chartData) {
            const chartControlsWrapper = document.createElement('div');
            chartControlsWrapper.style.marginBottom = '10px';
            const chartTypeSelect = document.createElement('select');
            chartTypeSelect.innerHTML = `
                <option value="bar">Bar Chart</option>
                <option value="line">Line Chart</option>
                <option value="scatter">Scatter Plot</option>
                <option value="pie">Pie Chart</option>
            `;
            chartTypeSelect.style.marginRight = '10px';
            const xAxisSelect = document.createElement('select');
            xAxisSelect.innerHTML = Object.keys(chartData.columnData).map(column =>
                `<option value="${column}">${column}</option>`
            ).join('');
            xAxisSelect.style.marginRight = '10px';
            const yAxisSelect = document.createElement('select');
            yAxisSelect.innerHTML = Object.keys(chartData.columnData).map(column =>
                `<option value="${column}">${column}</option>`
            ).join('') + Object.keys(chartData.columnCounts).map(column =>
                `<option value="${column}">${column}</option>`
            ).join('');
            yAxisSelect.style.marginRight = '10px';
            const scaleControlWrapper = document.createElement('div');
            scaleControlWrapper.style.marginTop = '10px';
            const scaleLabel = document.createElement('label');
            scaleLabel.textContent = 'Y-Axis Scale: ';
            scaleLabel.style.marginRight = '10px';
            const scaleSlider = document.createElement('input');
            scaleSlider.type = 'range';
            scaleSlider.min = '0.1';
            scaleSlider.max = '1';
            scaleSlider.step = '0.1';
            scaleSlider.value = '1';
            scaleSlider.style.width = '200px';
            const scaleValue = document.createElement('span');
            scaleValue.textContent = '1x';
            scaleValue.style.marginLeft = '10px';
            scaleControlWrapper.appendChild(scaleLabel);
            scaleControlWrapper.appendChild(scaleSlider);
            scaleControlWrapper.appendChild(scaleValue);
            chartControlsWrapper.appendChild(chartTypeSelect);
            chartControlsWrapper.appendChild(xAxisSelect);
            chartControlsWrapper.appendChild(yAxisSelect);
            chartControlsWrapper.appendChild(scaleControlWrapper);
            const chartContainer = document.createElement('div');
            chartContainer.style.width = '100%';
            chartContainer.style.height = 'calc(100% - 80px)';
            chartContainer.style.position = 'relative';
            const chartCanvas = document.createElement('canvas');
            chartCanvas.style.width = '100%';
            chartCanvas.style.height = '100%';
            chartContainer.appendChild(chartCanvas);
            chartWrapper.appendChild(chartControlsWrapper);
            chartWrapper.appendChild(chartContainer);
            const ctx = chartCanvas.getContext('2d');
            let chart = new Chart(ctx, chartData);
            const updateChart = () => {
                const selectedType = chartTypeSelect.value;
                const xAxis = xAxisSelect.value;
                const yAxis = yAxisSelect.value;
                this.updateChartType(chart, selectedType, chartData.columnData, chartData.columnCounts, xAxis, yAxis);
                this.updateChartScale(chart, parseFloat(scaleSlider.value));
            };
            chartTypeSelect.onchange = updateChart;
            xAxisSelect.onchange = updateChart;
            yAxisSelect.onchange = updateChart;
            scaleSlider.oninput = () => {
                scaleValue.textContent = `${scaleSlider.value}x`;
                this.updateChartScale(chart, parseFloat(scaleSlider.value));
            };
        }
        container.appendChild(contentWrapper);
        container.appendChild(chartWrapper);
        const closeButton = document.createElement('button');
        closeButton.textContent = 'Close';
        closeButton.style.marginTop = '10px';
        closeButton.style.padding = '5px 10px';
        closeButton.style.cursor = 'pointer';
        closeButton.onclick = () => document.body.removeChild(modal);
        container.appendChild(closeButton);
        modal.appendChild(container);

        return modal;
    }

    async parseFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const data = event.target.result;
                if (file.type === 'text/csv') {
                    const parsed = Papa.parse(data, { header: true });
                    resolve(parsed.data);
                } else if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    const workbook = XLSX.read(data, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0];
                    const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    resolve(sheetData);
                } else {
                    reject(new Error('Unsupported file type'));
                }
            };
            if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                reader.readAsBinaryString(file);
            } else {
                reader.readAsText(file);
            }
        });
    }

    createTableFromData(data) {
        const columns = Object.keys(data[0]);
        const rows = data.map(row => columns.map(column => row[column] || ''));
        return { columns, rows };
    }

    showUploadedData(data, contentWrapper) {
        const tableElement = document.createElement('table');
        tableElement.style.borderCollapse = 'collapse';
        tableElement.style.width = '100%';
        // Add table header
        const headerRow = document.createElement('tr');
        Object.keys(data[0]).forEach(column => {
            const th = document.createElement('th');
            th.textContent = column;
            th.style.border = '1px solid black';
            th.style.padding = '5px';
            headerRow.appendChild(th);
        });
        tableElement.appendChild(headerRow);
        // Add table rows
        data.forEach(row => {
            const tr = document.createElement('tr');
            Object.values(row).forEach(cell => {
                const td = document.createElement('td');
                td.textContent = cell;
                td.style.border = '1px solid black';
                td.style.padding = '5px';
                tr.appendChild(td);
            });
            tableElement.appendChild(tr);
        });
        // Clear previous content and append new table
        contentWrapper.innerHTML = '';
        contentWrapper.appendChild(tableElement);
    }

    updateChartType(chart, type, columnData, columnCounts, xAxis, yAxis) {
        const xData = columnData[xAxis];
        let yData;
        let labels;
        if (yAxis.startsWith('Count of ')) {
            const countData = columnCounts[yAxis];
            yData = Object.values(countData);
            labels = Object.keys(countData);
        } else {
            yData = columnData[yAxis];
            labels = xData;
        }
        const datasets = [];
        const colors = this.generateColors(yData.length);

        if (type === 'bar' || type === 'line') {
            datasets.push({
                type: type,
                label: yAxis,
                data: yData,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 1,
                fill: false
            });
        } else if (type === 'scatter') {
            datasets.push({
                type: 'scatter',
                label: `${yAxis} vs ${xAxis}`,
                data: labels.map((x, i) => ({ x: parseFloat(x) || 0, y: parseFloat(yData[i]) || 0 })),
                backgroundColor: colors[0],
                borderColor: colors[0],
                pointRadius: 5,
                pointHoverRadius: 7,
            });
        } else if (type === 'pie') {
            datasets.push({
                type: 'pie',
                label: yAxis,
                data: yData,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 1
            });
        }
        chart.data.labels = labels;
        chart.data.datasets = datasets;
        chart.config.type = type;
        // Update chart options based on type
        if (type === 'pie') {
            chart.options.scales = {}; // Remove scales for pie chart
            chart.options.plugins.legend = { display: true }; // Show legend for pie chart
        } else {
            const minY = 0; // Always start from zero
            const maxY = Math.max(...yData.map(v => parseFloat(v) || 0));
            chart.options.scales = {
                x: {
                    type: type === 'scatter' ? 'linear' : 'category',
                    position: 'bottom',
                    title: { display: true, text: xAxis }
                },
                y: {
                    type: 'linear',
                    title: { display: true, text: yAxis },
                    beginAtZero: true, // Always start at zero
                    min: 0, // Set the minimum to 0
                    max: maxY * 1.1, // Add 10% padding to the top
                    ticks: {
                        stepSize: Math.ceil(maxY / 10) // Adjust step size for better readability
                    }
                }
            };
            // Special handling for bar charts
            if (type === 'bar') {
                chart.options.scales.y.grace = '5%'; // Add some padding at the top
            }
        }
        chart.options.responsive = true;
        chart.options.maintainAspectRatio = false;
        // Update tooltips to show both x and y values
        chart.options.plugins.tooltip = {
            callbacks: {
                label: function (context) {
                    let label = context.dataset.label || '';
                    if (label) {
                        label += ': ';
                    }
                    if (type === 'scatter') {
                        label += `(${context.parsed.x}, ${context.parsed.y})`;
                    } else {
                        label += context.parsed.y;
                    }
                    return label;
                }
            }
        };
        chart.update();
    }

    updateChartScale(chart, scale) {
        const yAxis = chart.options.scales.y;
        if (yAxis) {
            const originalMin = yAxis.originalMin || 0;
            const originalMax = yAxis.originalMax || Math.max(...chart.data.datasets[0].data);
            yAxis.min = originalMin / scale;
            yAxis.max = originalMax / scale;
            chart.update();
        }
    }

    showTable(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        if (!this.tables.hasOwnProperty(tableName)) {
            alert(`Table "${tableName}" does not exist`);
            return;
        }
        const table = this.tables[tableName];
        // Create the table element
        const tableElement = document.createElement('table');
        tableElement.style.borderCollapse = 'collapse';
        tableElement.style.width = '100%';
        tableElement.style.tableLayout = 'fixed';
        // Create table header
        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        table.columns.forEach(column => {
            const th = document.createElement('th');
            th.textContent = column;
            th.style.border = '1px solid black';
            th.style.padding = '5px';
            th.style.overflow = 'hidden';
            th.style.textOverflow = 'ellipsis';
            th.style.whiteSpace = 'nowrap';
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        tableElement.appendChild(thead);
        // Create table body
        const tbody = document.createElement('tbody');
        table.rows.forEach(row => {
            const tr = document.createElement('tr');
            row.forEach(cell => {
                const td = document.createElement('td');
                td.textContent = cell;
                td.style.border = '1px solid black';
                td.style.padding = '5px';
                td.style.overflow = 'hidden';
                td.style.textOverflow = 'ellipsis';
                td.style.whiteSpace = 'nowrap';
                tr.appendChild(td);
            });
            tbody.appendChild(tr);
        });
        tableElement.appendChild(tbody);
        // Prepare data for the chart
        let chartData;
        if (table.columns.length >= 1) {
            const columnData = {};
            const columnCounts = {};
            table.columns.forEach((column, index) => {
                columnData[column] = table.rows.map(row => row[index]);
                columnCounts[`Count of ${column}`] = this.calculateColumnCounts(columnData[column]);
            });
            chartData = {
                type: 'bar',
                data: {
                    labels: table.rows.map((_, index) => `Row ${index + 1}`),
                    datasets: [{
                        type: 'bar',
                        label: table.columns[0],
                        data: columnData[table.columns[0]],
                        backgroundColor: this.generateColors(table.rows.length),
                        borderColor: this.generateColors(table.rows.length),
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                callback: function (value, index, values) {
                                    return value.toExponential();
                                }
                            }
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: 'Interactive Chart'
                        }
                    }
                },
                columnData: columnData,
                columnCounts: columnCounts
            };
        } else {
            chartData = null;
        }
        // Create and show the modal
        const modal = this.createModal(tableElement, `Table: ${tableName}`, chartData);
        document.body.appendChild(modal);
    }

    // Add this helper method to generate colors
    generateColors(count) {
        const colors = [];
        for (let i = 0; i < count; i++) {
            colors.push(`hsl(${(i * 360) / count}, 70%, 60%)`);
        }
        return colors;
    }

    async uploadFile() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.csv, .xlsx';
        input.onchange = async (event) => {
            const file = event.target.files[0];
            if (file) {
                const tableName = file.name.split('.')[0]; // Use file name as table name
                const fileData = await this.parseFile(file);
                this.tables[tableName] = this.createTableFromData(fileData);
                this.showTableWithCharts(tableName, fileData);
            }
        };
        input.click();
    }

    showTableWithCharts(tableName, fileData) {
        const tableElement = document.createElement('table');
        tableElement.style.borderCollapse = 'collapse';
        tableElement.style.width = '100%';
        // Table header
        const headerRow = document.createElement('tr');
        Object.keys(fileData[0]).forEach(column => {
            const th = document.createElement('th');
            th.textContent = column;
            th.style.border = '1px solid black';
            th.style.padding = '5px';
            headerRow.appendChild(th);
        });
        tableElement.appendChild(headerRow);
        // Table rows
        fileData.forEach(row => {
            const tr = document.createElement('tr');
            Object.values(row).forEach(cell => {
                const td = document.createElement('td');
                td.textContent = cell;
                td.style.border = '1px solid black';
                td.style.padding = '5px';
                tr.appendChild(td);
            });
            tableElement.appendChild(tr);
        });
        // Prepare data for the chart
        const columnData = {};
        const columnCounts = {};
        Object.keys(fileData[0]).forEach(column => {
            columnData[column] = fileData.map(row => row[column]);
            columnCounts[`Count of ${column}`] = this.calculateColumnCounts(columnData[column]);
        });
        const chartData = {
            columnData: columnData,
            columnCounts: columnCounts
        };
        // Display table with chart options
        const modal = this.createModal(tableElement, `Table: ${tableName}`, chartData);
        document.body.appendChild(modal);
    }
    extractRow(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const rowIndex = Cast.toNumber(args.ROW_INDEX) - 1; // Convert to 0-based index

        // Check if the table exists
        if (!this.tables.hasOwnProperty(tableName)) {
            alert(`Table "${tableName}" does not exist.`);
            return;
        }

        const table = this.tables[tableName];

        // Check if the row index is valid
        if (rowIndex < 0 || rowIndex >= table.rows.length) {
            alert(`Row index "${rowIndex + 1}" is out of range for table "${tableName}".`);
            return;
        }

        // Extract the row data
        const rowData = table.rows[rowIndex];

        // Create the table element
        const tableElement = document.createElement('table');
        tableElement.style.borderCollapse = 'collapse';
        tableElement.style.width = '50%';
        tableElement.style.margin = '0 auto';
        tableElement.style.tableLayout = 'fixed';

        // Create table header
        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        table.columns.forEach(column => {
            const th = document.createElement('th');
            th.textContent = column;
            th.style.border = '1px solid black';
            th.style.padding = '5px';
            th.style.backgroundColor = '#f2f2f2';
            th.style.textAlign = 'center';
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        tableElement.appendChild(thead);

        // Create table body
        const tbody = document.createElement('tbody');
        const rowElement = document.createElement('tr');
        rowData.forEach(cell => {
            const td = document.createElement('td');
            td.textContent = cell;
            td.style.border = '1px solid black';
            td.style.padding = '5px';
            td.style.textAlign = 'center';
            rowElement.appendChild(td);
        });
        tbody.appendChild(rowElement);
        tableElement.appendChild(tbody);

        // Create and show the modal
        const modal = this.createModal(tableElement, `Row ${rowIndex + 1} from Table: ${tableName}`);
        document.body.appendChild(modal);
    }
    selectQuery(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const columns = Cast.toString(args.COLUMNS).trim();
    
        // Check if the table exists
        if (!this.tables.hasOwnProperty(tableName)) {
            alert(`Table "${tableName}" does not exist.`);
            return;
        }
    
        const table = this.tables[tableName];
    
        // Parse column names or select all (*)
        const selectedColumns = columns === '*'
            ? table.columns
            : columns.split(',').map(col => col.trim());
    
        // Validate column names
        const columnIndexes = selectedColumns.map(col => table.columns.indexOf(col));
        if (columnIndexes.includes(-1)) {
            alert(`One or more column names in "${columns}" do not exist in table "${tableName}".`);
            return;
        }
    
        // Filter rows based on WHERE condition
        let filteredRows = table.rows;
        if (
            this.currentWhereCondition &&
            this.currentWhereCondition.table === tableName
        ) {
            try {
                const { condition } = this.currentWhereCondition;
                const columns = table.columns;

                // Create a safe mapping for column replacements only
                let safeCondition = condition;

                // Replace only known column names with `row[columnIndex["COLUMN"]]`
                columns.forEach(col => {
                    const regex = new RegExp(`\\b${col}\\b`, 'g');
                    safeCondition = safeCondition.replace(
                        regex,
                        `row[columnIndex["${col}"]]`
                    );
                });
                const conditionFunction = new Function(
                    'row',
                    'columns',
                    `
                    const columnIndex = columns.reduce((acc, col, idx) => ({ ...acc, [col]: idx }), {});
                    return ${safeCondition};
                    `
                );
                filteredRows = filteredRows.filter(row =>
                    conditionFunction(row, table.columns)
                );
            } catch (e) {
                alert('Error in WHERE condition. Please check the syntax.');
                console.error(e);
                return;
            }
        }
    
        // Extract the selected columns
        const resultRows = filteredRows.map(row =>
            columnIndexes.map(index => row[index])
        );
    
        // Render the table
        this.renderTable(selectedColumns, resultRows, tableName);
    
        // Clear WHERE condition to avoid persistence
        this.clearWhereCondition();
    }
    
    renderTable(columns, rows, tableName) {
        // Create the table element
        const tableElement = document.createElement('table');
        tableElement.style.borderCollapse = 'collapse';
        tableElement.style.width = '50%';
        tableElement.style.margin = '0 auto';
        tableElement.style.tableLayout = 'fixed';
    
        // Create table header
        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        columns.forEach(column => {
            const th = document.createElement('th');
            th.textContent = column;
            th.style.border = '1px solid black';
            th.style.padding = '5px';
            th.style.backgroundColor = '#f2f2f2';
            th.style.textAlign = 'center';
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        tableElement.appendChild(thead);
    
        // Create table body
        const tbody = document.createElement('tbody');
        rows.forEach(row => {
            const rowElement = document.createElement('tr');
            row.forEach(cell => {
                const td = document.createElement('td');
                td.textContent = cell;
                td.style.border = '1px solid black';
                td.style.padding = '5px';
                td.style.textAlign = 'center';
                rowElement.appendChild(td);
            });
            tbody.appendChild(rowElement);
        });
        tableElement.appendChild(tbody);
    
        // Create and show the modal
        const modal = this.createModal(tableElement, `Data from Table: ${tableName}`);
        document.body.appendChild(modal);
    }
    
    whereClause(args) {
        const table = Cast.toString(args.TABLE).trim();
        const condition1 = Cast.toString(args.CONDITION1).trim();
        const operator = Cast.toString(args.OPERATOR).trim();
        const condition2 = Cast.toString(args.CONDITION2).trim();
    
        if (!table || !this.tables[table]) {
            alert(`Table "${table}" does not exist.`);
            return;
        }
    
        // Construct the WHERE condition
        let condition = '';
        switch (operator) {
            case 'BETWEEN':
                const [start, end] = condition2.split('AND').map(v => v.trim());
                condition = `${condition1} >= '${start}' && ${condition1} <= '${end}'`;
                break;
    
            case 'IN':
                const values = condition2.split(',').map(v => `'${v.trim()}'`).join(',');
                condition = `[${values}].includes(${condition1})`;
                break;
    
            case 'IS NULL':
                condition = `${condition1} === null`;
                break;
    
            case 'IS NOT NULL':
                condition = `${condition1} !== null`;
                break;
    
            case 'LIKE':
                const regex = condition2.replace(/%/g, '.*').replace(/_/g, '.');
                condition = `new RegExp('^${regex}$').test(${condition1})`;
                break;
            
            case '<>':
                condition = `${condition1} != '${condition2}'`;
                break;
    
            default:
                condition = `${condition1} ${operator} '${condition2}'`;
                break;
        }
    
        // Store the condition for the table
        this.currentWhereCondition = { table, condition };
        console.log(`Updated WHERE clause for table "${table}": ${condition}`);
    }
    clearWhereCondition() {
        this.currentWhereCondition = null;
        console.log('Cleared WHERE condition.');
    }
    orderByQuery(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const columnName = Cast.toString(args.COLUMN_NAME).trim();
        const order = Cast.toString(args.ASC_DESC).trim();  // "asc" or "desc"
        
        // Check if the table exists
        if (!this.tables.hasOwnProperty(tableName)) {
            alert(`Table "${tableName}" does not exist.`);
            return;
        }
    
        const table = this.tables[tableName];
    
        // Check if the column exists
        const columnIndex = table.columns.indexOf(columnName);
        if (columnIndex === -1) {
            alert(`Column "${columnName}" does not exist in table "${tableName}".`);
            return;
        }
    
        // Defensive copy to avoid mutating the original rows
        const rowsCopy = [...table.rows];

        // Determine if column contains numbers or strings
        const isNumeric = rowsCopy.every(row => !isNaN(parseFloat(row[columnIndex])));

        // Sort the rows based on column type and order
        rowsCopy.sort((a, b) => {
            let valueA = a[columnIndex];
            let valueB = b[columnIndex];

            if (isNumeric) {
                valueA = parseFloat(valueA);
                valueB = parseFloat(valueB);
            } else {
                valueA = String(valueA).toLowerCase();
                valueB = String(valueB).toLowerCase();
            }

            if (order === 'asc') {
                return valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
            } else if (order === 'desc') {
                return valueA > valueB ? -1 : (valueA < valueB ? 1 : 0);
            } else {
                alert(`Invalid sort order "${order}". Use "asc" or "desc".`);
                return 0;
            }
        });
    
        // Render the sorted table
        this.renderTable(table.columns, rowsCopy, tableName);
    }
    groupByQuery(args) {
        const tableName = Cast.toString(args.TABLE_NAME).trim();
        const columnsToGroupBy = Cast.toString(args.COLUMNS).trim().split(',').map(col => col.trim());
    
        if (!this.tables.hasOwnProperty(tableName)) {
            alert(`Table "${tableName}" does not exist.`);
            return;
        }
    
        const table = this.tables[tableName];
    
        // Validate that all group by columns exist in the table
        const invalidColumns = columnsToGroupBy.filter(col => !table.columns.includes(col));
        if (invalidColumns.length > 0) {
            alert(`Columns "${invalidColumns.join(', ')}" do not exist in table "${tableName}".`);
            return;
        }
    
        // Group rows by the selected columns
        const groupedRows = table.rows.reduce((groups, row) => {
            // Create a composite key from the values of the group by columns
            const key = columnsToGroupBy.map(col => row[table.columns.indexOf(col)]).join('|');
            
            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(row); // Add the current row to the corresponding group
            return groups;
        }, {});
    
        // Prepare the result rows for display
        const resultRows = Object.keys(groupedRows).map(key => {
            const group = groupedRows[key];
    
            // Create an aggregated row for the group
            return table.columns.map((columnName, colIndex) => {
                if (columnsToGroupBy.includes(columnName)) {
                    // For grouped columns, we just need to display the grouped value from the key
                    return key.split('|')[columnsToGroupBy.indexOf(columnName)];
                }
    
                // For non-grouped columns, we perform an aggregation (e.g., joining the values)
                return group.map(row => row[colIndex]).join(", "); // Join values of non-grouped columns
            });
        });
    
        // Render the table with the grouped data
        this.renderTable(table.columns, resultRows, tableName);
    }    
    havingClause(args) {
        const table = Cast.toString(args.TABLE_NAME).trim();
        const column = Cast.toString(args.COLUMN).trim();
        const comparisonOperator = Cast.toString(args.COMPARISON_OPERATOR).trim();
        const value = Cast.toString(args.VALUE).trim();
        
        if (!table || !this.tables[table]) {
            alert(`Table "${table}" does not exist.`);
            return;
        }
        
        const conditionFunction = (rowValue) => {
            switch (comparisonOperator) {
                case '>':
                    return rowValue > value;
                case '<':
                    return rowValue < value;
                case '=':
                    return rowValue === value;
                case '>=':
                    return rowValue >= value;
                case '<=':
                    return rowValue <= value;
                case '<>':
                    return rowValue !== value;
                default:
                    return false;
            }
        };
        
        // Filter groups after applying the HAVING condition
        const tableData = this.tables[table];
        const filteredRows = tableData.rows.filter(row => {
            const columnValue = row[tableData.columns.indexOf(column)];
            return conditionFunction(columnValue);
        });
        
        // Render the filtered table
        this.renderTable(tableData.columns, filteredRows, table);
    }
    aggregateFunctions(args) {
        const func = Cast.toString(args.FUNCTION).trim().toUpperCase();
        const column = Cast.toString(args.COLUMN).trim();
        const tableName = Cast.toString(args.TABLE_NAME).trim();
    
        // Validate table and column
        if (!this.tables[tableName]) {
            alert(`Table "${tableName}" does not exist.`);
            return;
        }
    
        const tableData = this.tables[tableName];
        if (!tableData.columns.includes(column)) {
            alert(`Column "${column}" does not exist in table "${tableName}".`);
            return;
        }
    
        const columnIndex = tableData.columns.indexOf(column);
        let rows = tableData.rows;
    
        // Check if there is a current group-by clause
        if (this.currentGroupByColumn) {
            const groupColumnIndex = tableData.columns.indexOf(this.currentGroupByColumn);
            if (groupColumnIndex === -1) {
                alert(`Group column "${this.currentGroupByColumn}" does not exist in table "${tableName}".`);
                return;
            }
    
            // Group rows
            const groupedRows = rows.reduce((groups, row) => {
                const key = row[groupColumnIndex];
                if (!groups[key]) groups[key] = [];
                groups[key].push(row);
                return groups;
            }, {});
    
            // Apply the aggregate function to each group
            rows = Object.entries(groupedRows).map(([group, groupRows]) => {
                const values = groupRows.map(row => Number(row[columnIndex]));
                let result;
                switch (func) {
                    case 'SUM':
                        result = values.reduce((sum, val) => sum + val, 0);
                        break;
                    case 'AVERAGE':
                        result = values.reduce((sum, val) => sum + val, 0) / values.length;
                        break;
                    case 'STDDEV':
                        const mean = values.reduce((sum, val) => sum + val, 0) / values.length;
                        const variance = values.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / values.length;
                        result = Math.sqrt(variance);
                        break;
                    default:
                        alert(`Unsupported aggregate function: "${func}".`);
                        return;
                }
                return { group, result };
            });
    
            // Render grouped and aggregated result
            const resultColumns = [this.currentGroupByColumn, `${func}(${column})`];
            const resultRows = rows.map(({ group, result }) => [group, result]);
            this.renderTable(resultColumns, resultRows, `${tableName}_Aggregated`);
        } else {
            // Apply the aggregate function to all rows (no grouping)
            const values = rows.map(row => Number(row[columnIndex]));
            let result;
            switch (func) {
                case 'SUM':
                    result = values.reduce((sum, val) => sum + val, 0);
                    break;
                case 'AVERAGE':
                    result = values.reduce((sum, val) => sum + val, 0) / values.length;
                    break;
                case 'STDDEV':
                    const mean = values.reduce((sum, val) => sum + val, 0) / values.length;
                    const variance = values.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / values.length;
                    result = Math.sqrt(variance);
                    break;
                default:
                    alert(`Unsupported aggregate function: "${func}".`);
                    return;
            }
    
            // Render non-grouped aggregate result
            const resultColumns = [`${func}(${column})`];
            const resultRows = [[result]];
            this.renderTable(resultColumns, resultRows, `${tableName}_Aggregated`);
        }
    }

    clear() {
        if (typeof document !== 'undefined') {
            try {
                const modals = document.querySelectorAll('.stemblocks-table-modal, .stemblocks-overlay-modal');
                modals.forEach(m => m.remove());
            } catch (e) {}
        }
        this.tables = {};
    }

    clearCanvas() {
        this.clear();
    }
}

module.exports = Scratch3TableCharts;